/* Events codes */

export const LOGIN = 1;
export const LOGOUT = 2;
export const ACTIVE = 3;
export const VIEW_CHANGE = 4;


